import { render, staticRenderFns } from "./EditorMockup.vue?vue&type=template&id=daa06830&scoped=true&"
import script from "./EditorMockup.vue?vue&type=script&lang=js&"
export * from "./EditorMockup.vue?vue&type=script&lang=js&"
import style0 from "./EditorMockup.vue?vue&type=style&index=0&id=daa06830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa06830",
  null
  
)

export default component.exports